import firebase from 'firebase'

require('firebase/firestore')

export default {
  data () {
    return {
      user: {},
      db: null
    }
  },
  async mounted () {
    await this.setUpFirebase()

    this.db = firebase.firestore()
    const settings = { timestampsInSnapshots: true }
    this.db.settings(settings)
  },
  methods: {
    async setUpFirebase () {
      const config = {
        apiKey: 'AIzaSyBIk2j_fy6LJT5XHPUmuJDgcDOCalF1bsU',
        authDomain: 'smallbiz-ce0db.firebaseapp.com',
        databaseURL: 'https://smallbiz-ce0db.firebaseio.com',
        projectId: 'smallbiz-ce0db',
        storageBucket: 'smallbiz-ce0db.appspot.com',
        messagingSenderId: '1088167687437'
      }

      if (firebase.apps.length) return

      await firebase.initializeApp(config)
    },
    firebaseLogout () {
      this.user = {}
      this.$router.push({ name: 'Home' })
      return firebase.auth().signOut()
    },
    async storeCompanyInfo (companyInfo) {
      const userRef = this.db.collection('users')
      const userDoc = await userRef.doc(this.user.uid)

      const userItem = userDoc.get()

      if (userItem.exists) {
        userDoc.update({ companyInfo })
        return
      }

      userDoc.set({ companyInfo })
    },
    async sendContact (companyInfo) {
      this.db.collection('contacts').add({ companyInfo })
    },
    async storeProcessingAccounts (accountIndex, accountsToProcess) {
      const userRef = this.db.collection('users')
      const userDoc = await userRef.doc(this.user.uid)
      const userItem = await userDoc.get()

      const { accounts } = userItem.data()
      accounts[accountIndex].processingAccounts = accountsToProcess

      userDoc.update({ accounts })
    },
    async updateAccountName (accountIndex, displayName) {
      const userRef = this.db.collection('users')
      const userDoc = await userRef.doc(this.user.uid)
      const userItem = await userDoc.get()

      const { accounts } = userItem.data()
      accounts[accountIndex].displayName = displayName

      userDoc.update({ accounts })
    },
    async firebaseRemoveAccount (accountIndex) {
      const userRef = this.db.collection('users')
      const userDoc = await userRef.doc(this.user.uid)

      const userItem = await userDoc.get()

      const { accounts } = userItem.data()

      const newAccounts = accounts.filter(acc => acc.item_id !== accountIndex)

      userDoc.update({ accounts: newAccounts })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/firebase.js